import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ReviewRefinePage = lazy(
  () => import('~/features/content-enrichment/pages/review-refine-page'),
);

/** Step 1 — Review & Refine page for the Google Ads enrichment funnel. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/review',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ReviewRefinePage />
    </Suspense>
  ),
});
